export type ApplyWeldIdMode = 'catalog' | 'local'

export type Data360CatalogMatch = {
  weldName: string
  productionWeldId: number
  jobNumber?: string
}

export type ApplyWeldIdDecision =
  | { kind: 'switch-row'; rowId: string }
  | { kind: 'catalog-missing' }
  | { kind: 'catalog-import'; match: Data360CatalogMatch }
  | { kind: 'set-local'; weldId: string }

export type DecideApplyWeldIdToRowInput = {
  targetRowId: string
  value: string
  mode?: ApplyWeldIdMode
  welds: Array<{ id: string; weldId?: unknown; weldNumber?: unknown }>
  data360Linked: boolean
  hasProjectAndPipe: boolean
  findWeldByName: (name: string) => Data360CatalogMatch | undefined
}

/**
 * Decide how to apply a Weld ID to a Floor Sheet row.
 *
 * `catalog` (default) is the grid cell: Data360-linked projects must pick from
 * the production list. `local` is the upload dialog: set the label without
 * importing Data360 telemetry.
 */
export function decideApplyWeldIdToRow(input: DecideApplyWeldIdToRowInput): ApplyWeldIdDecision {
  const trimmed = input.value.trim()
  const other = input.welds.find(
    (w) =>
      w.id !== input.targetRowId &&
      trimmed &&
      (String(w.weldId || '').trim() === trimmed || String(w.weldNumber || '').trim() === trimmed)
  )
  if (other) return { kind: 'switch-row', rowId: other.id }

  const useCatalog =
    (input.mode ?? 'catalog') === 'catalog' && input.data360Linked && input.hasProjectAndPipe

  if (useCatalog) {
    const match = input.findWeldByName(trimmed)
    if (!match) return { kind: 'catalog-missing' }
    return { kind: 'catalog-import', match }
  }

  return { kind: 'set-local', weldId: input.value }
}
